<template>
  <div class="column is-full" v-if="value">
    <div class="box">
      <div v-if="checkServiceVersion(2) && serviceInfo" class="plan-wrapper">
        <div class="flex-between">
          <div>
            <div class="size-11 gray">{{ serviceInfo.service_type === 4 ? '플랜/멤버십' : '스킨' }}</div>
            <div class="size-16 weight-700">
              <span v-if="serviceInfo.plan.trial">무료체험<span class="d-day">D-{{ serviceInfo.plan.d_day }}</span></span>
              <template v-if="serviceInfo.service_type === 4">{{ serviceInfo.membership_name }}</template>
              <template v-if="!serviceInfo.plan.trial && serviceInfo.service_type === 5">{{ serviceInfo.plan.product.name }}</template>
            </div>
          </div>
          <button class="button is-primary" v-if="serviceInfo.next_plan" @click="clickInquiry()">문의하기</button>
          <button class="button is-primary" v-else-if="(serviceInfo.service_type===5 && serviceInfo.plan.trial) || (serviceInfo.service_type===4)"
                  @click="plan">{{ serviceInfo.service_type === 4 ? '플랜' : '스킨' }} {{ serviceInfo.plan.trial ? '결제' : '변경' }}</button>
        </div>
        <!--<div v-if="serviceInfo.service_type === 4 && serviceInfo.plan.trial" class="msg-trial">무료체험 기간 내 3,6,12개월 플랜선택 및 결제 시 혜택제공
          <div class="triangle"></div>
        </div>-->
        <div v-if="serviceInfo.service_type === 4 && serviceInfo.plan.trial"
             class="position-relative" style="margin-top:16px">
          <slick ref="slick" :options="slickOptions"
                 @beforeChange="handleBeforeChange"
                 @afterChange="handleAfterChange">
            <img :src="imgSrc('img_event_1')" @click="clickEvent1">
            <img :src="imgSrc('img_event_2')" @click="clickEvent2">
          </slick>
          <div class="unselect arrow left" @click="$refs.slick.prev()">
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 1L1 5L5 9" stroke="white"/>
            </svg>
          </div>
          <div class="unselect arrow right" @click="$refs.slick.next()">
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L5 5L1 9" stroke="white"/>
            </svg>
          </div>
        </div>

        <div v-if="serviceInfo.next_plan" style="margin-top:8px"
             class="size-11 primary">{{ datesFormat(serviceInfo.next_plan.start_date, 'date_3')}} 이후로
          <span class="weight-600">{{ serviceInfo.next_plan.name }} ({{ serviceInfo.next_plan.date_unit }}개월) </span>
           플랜으로 변경됩니다.</div>
      </div>
      <div v-else class="panel-header">
        <div class="panel-title">솔루션 이용 현황</div>
      </div>
      <div class="panel-content">
        <!-- GA -->
        <div class="ga">
          <div class="flex-align unselect" style="gap:0 8px" @click="openLink(2)">
            <img :src="svgSrc('u_chart-line')" alt="chart line">
            <div class="sub2 body4-bold">사이트 유입 지표 현황</div>
            <img :src="svgSrc('u_arrow-up-right')" alt="chart line">
          </div>
        </div>
        <!-- 이용량 -->
        <div v-if="checkServiceVersion(2) &&
                    ((serviceInfo.plan.trial && serviceInfo.service_type === 5) || serviceInfo.service_type === 4) &&
                    value.usage && serviceInfo.usage"
          class="grid-content" style="padding-bottom:0">
          <div class="grid-content-title">이용량</div>
          <div class="grid-content-content">
            <div v-for="(uItem,uidx) in usage" :key="`usage-${uidx}`"
                 class="flex-align size-11">
              <div class="sub2 col-3">{{ uItem.label }}</div>
              <div class="progress-bar col-6">
                <div :style="currentProgressBarStyle(uItem.value)"></div>
              </div>
              <div class="col-3" style="text-align:right">{{ value.usage[uItem.value] }}
                <span style="color:#aeaeae;margin-left:4px">/{{ serviceInfo.usage[uItem.value] }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-content">
          <div class="grid-content-title">데이터사용량</div>
          <div class="grid-content-content size-12">{{ disk_usage }}</div>
        </div>
        <div class="lp-divider-gray2"></div>

        <!-- 주문방식 -->
        <template  v-if="serviceInfo.service_type === 4">
          <div class="grid-content">
            <div class="grid-content-title">주문방식(팩)</div>
            <div class="grid-content-content">
              <div class="flex" style="justify-content: space-between;gap:0 8px">
                <div>
                  <div v-for="(pack, idx) in value.service_setting.packages"
                  class="body5" :key="`pack-${idx}`">{{ convertPackName(pack) }}
                </div>
                </div>
                <div v-if="checkServiceVersion(2) && !stopAdmin"
                  class="unselect size-13 primary" @click="addPack">추가</div>
              </div>
            </div>
          </div>
          <div class="lp-divider-gray2"></div>
        </template>

        <!-- 호스팅 -->
        <template v-if="checkServiceVersion(2) && !serviceInfo.plan.trial">
        <div class="grid-content">
          <div class="grid-content-title">호스팅</div>
          <div class="grid-content-content">
            <div class="flex" style="justify-content: space-between;gap:0 8px">
              <div class="size-12">{{ serviceInfo.hosting }}</div>
              <div v-if="!stopAdmin"
                   class="unselect size-13 primary" @click="clickInquiry(6)">문의</div>
            </div>
          </div>
        </div>
        <div class="lp-divider-gray2"></div>
        </template>

        <!-- 결제정보 -->
        <template v-if="next_date_info">
          <div class="grid-content">
            <div class="grid-content-title">결제정보</div>
            <div class="grid-content-content">
              <div class="flex" style="justify-content: space-between;gap:0 8px">
                <div v-if="serviceInfo.plan && serviceInfo.plan.trial">
                  <span class="text-dashed">{{ next_date_info.total_pay_price | currency }}</span>
                  <span style="margin-left:4px">무료체험</span>
                </div>
                <div v-else>
                  <div>결제 예정 금액 : {{ next_date_info.total_pay_price | currency }}</div>
                  <span v-if="next_date_info.next_date!==''" style="color:#aeaeae">({{datesFormat(next_date_info.next_date,'date_3') }})</span>
                </div>
                <div class="unselect size-13 primary" @click="$router.push('service/plan')">상세</div>
              </div>
            </div>
          </div>
          <div class="lp-divider-gray2"></div>
        </template>
        <!-- 도메인 -->
        <div class="grid-content">
          <div class="grid-content-title">도메인</div>
          <div class="grid-content-content">
            <div class="flex" style="justify-content: space-between;gap:0 8px">
              <div class="size-12">
                <div>{{ value.service_setting.domain.indexOf('launchpack.co.kr')>-1 ||
                  value.service_setting.domain.indexOf('platformfy.com')>-1 ? '기본' : '맞춤' }} 도메인</div>
                <div>{{ value.service_setting.domain }}</div>
              </div>
              <div v-if="checkServiceVersion(2) && serviceInfo.plan && !serviceInfo.plan.trial &&
                         value.service_setting.domain.indexOf('launchpack.co.kr') > -1 ||
                         value.service_setting.domain.indexOf('platformfy.com') > -1"
                class="unselect size-13 primary" @click="clickSsl">설정</div>
            </div>
          </div>
        </div>
        <div class="lp-divider-gray2"></div>

        <!-- 앱포팅 -->
        <div class="grid-content" v-if="false">
          <div class="grid-content-title">앱 포팅</div>
          <div class="grid-content-content">
            <button-app-porting
              :trial="serviceInfo && serviceInfo.plan ? serviceInfo.plan.trial : false"
              :service="value.service_setting"
              @plan="plan"></button-app-porting>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ToolTip from "../../module/common/ToolTip";
  import ButtonAppPorting from "../../module/common/ButtonAppPorting";
  import Slick from 'vue-slick';

  export default {
    name: "ServiceInfo",
    components: {
      ButtonAppPorting,
      ToolTip,
      Slick
    },
    props: {
      value: {
        type: Object
      }
    },
    created() {
      this.getDiskUsage();
      this.getLaunchpackServiceInfo();
    },
    data() {
      return {
        disk_usage: 0,
        service_s3bucket: 0,
        launchpack_s3bucket: 0,
        next_date_info: undefined,
        usage: [
          { label: '회원', value: 'user' },
          { label: '상품', value: 'product' },
          { label: '카테고리', value: 'category' },
          { label: '파트너', value: 'partner' },
          { label: '관리자', value: 'admin_account' },
        ],
        slickOptions: {
          infinite: true,
          autoplay: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 300,
          arrows: false
        },
        dragging: false
      }
    },
    watch: {
      serviceInfo: {
        handler() {
          this.getLaunchpackServiceInfo();
        },
        deep: true
      }
    },
    methods: {
      clickEvent1() {
        if(!this.dragging) {
          const a = document.createElement('a');
          a.href = 'https://platformfy.com/event';
          a.target = '_blank';
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          a.parentNode.removeChild(a);
        }
      },
      clickEvent2() {
        if(!this.dragging) {
          this.$root.$emit('planChangeModal');
        }
      },
      handleBeforeChange() {
        this.dragging = true;
      },

      handleAfterChange() {
        this.dragging = false;
      },
      plan() {
        this.$root.$emit('planChangeModal');
      },
      clickInquiry(cat=null) {
        let query = '';
        if(cat) {
          query = `?cat=${cat}`;
        }
        this.routerPush(`/office/admin/launchpack/inquiry/customer/create${query}`);
      },
      getSerivceNextDateInfo() {
        let url = `${this.masterBackendUrl}serviceadmin/${this.$store.getters.admin.id}/launchpack/v1/service/${this.serviceInfo.id}/next_date/info`;
        this.$axios.get(url).then(res => {
          this.next_date_info = res.data;
        })
      },
      donePlanChangeModal() {
        this.getLaunchpackServiceInfo();
      },
      currentProgressBarStyle(attr) {
        let rate = this.value.usage[attr] / this.serviceInfo.usage[attr];
        return {
          backgroundColor: '#FF6600',
          width: `${rate < 1 ? rate * 100 : 100}%`,
          height: '6px'
        };
      },
      addPack() {
        if (this.stopAdmin) return;
        this.$root.$emit('appMarket');
      },
      getDiskUsage() {
        this.$axios.get(this.getUrl('dashboard/disk')).then(res => {
          if (res.status === 200) {
            this.disk_usage = res.data.db;
            this.service_s3bucket = res.data.service_s3bucket;
            this.launchpack_s3bucket = res.data.launchpack_s3bucket;
          }
        })
      },
      getLaunchpackServiceInfo() {
        if(this.serviceInfo.plan && this.serviceInfo.plan.trial) {
          this.serviceInfo.usage.category = 5;
        }
        //this.getSerivceNextDateInfo();
      },
      openLink(type) {
        if (type === 1) {
          if (this.stopAdmin) return;
          if (this.isInternalPlugin('builder')) {
            window.open('/developers/ui/builder', '_blank');
          } else {
            this.$root.$emit('builder');
          }
        } else {
          window.open('https://analytics.google.com', '_blank');
        }
      },
      clickSsl() {
        if(this.serviceInfo.service_type === 4) {
          this.$root.$emit('appMarket', { detail: 155 });
        } else {
          this.routerPush('/office/admin/launchpack/inquiry/customer/create?cat=10');
        }
      },

    },
    computed: {
      serviceName() {
        return this.$store.getters.serviceName;
      },
      orderType() {
        return `주문방식(${this.serviceType ===1 ? '테마' : '팩'})`;
      },
    },
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .box
    padding 0

  .panel-header
    padding 16px 20px
    display flex
    align-items center
    justify-content space-between
    border-bottom 1px solid #eeeeee

  .panel-title
    color $main
    font-size 21px
    font-weight 300

  .panel-content
    padding 0

  .ga
    padding 20px 0
    border-bottom 1px solid #dddddd
    display flex
    align-items center
    justify-content center


  .grid-content
    display grid
    grid-template-columns 72px 1fr
    grid-gap 8px
    padding 16px 20px
    text-align left
    .grid-content-title
      font-size 12px
      font-weight 700
      line-height 17px
      color #363636
    .grid-content-content
      color #787878

  .tag-plan
    color $primary
    background-color $primary-light2
    font-size 12px
    padding 2px 4px
    border-radius 4px
    margin-left 4px

  .progress-bar
    border-radius 50px
    overflow hidden
    background-color #e3e3e3
    height 6px

  .plan-wrapper
    border-top-left-radius 5px
    border-top-right-radius 5px
    background-color #32373F
    color white
    padding 20px
    padding-bottom 16px
    .d-day
      color $primary
      margin 0 4px
    .flex-between
      gap 20px

  .msg-trial
    background #E6DFFF
    padding 4px 10px
    border-radius 4px
    margin-top 12px
    color #251432
    font-size 12px
    position relative
    .triangle
      position absolute
      top -10px
      border-left 6px solid transparent
      border-right 6px solid transparent
      border-bottom 10px solid #e6dfff
      width 0
      height 0
      right 16px

  .text-dashed
    text-decoration line-through
    color #aeaeae

  .arrow
    position absolute
    top calc(50% - 10px)
    background-color rgba(0,0,0,0.3)
    border-radius 50px
    height 20px
    width 16px
    display flex
    justify-content center
    align-items center



  .arrow.left
      left 6px
  .arrow.right
    right 6px


</style>
